import React, { useEffect } from 'react'
import I18n from 'i18n-js'
import { useDispatch, useSelector } from 'react-redux'
import * as CounselingCenterAction from './../../CounselingCenterAction'
import * as ConsultantAction from './../../../Consultant/ConsultantAction'

import { H1, H4 } from './../../../../components/UI/index'
import ConsultantCard from '../ConsultantCard/ConsultantCard'
import { useParams } from 'react-router-dom'

import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import styles from './ChooseConsultant.module.css'
import ConsultantCardProfile from '../../../Consultant/components/ConsultantCardProfile/ConsultantCardProfile'
import LanguageModalCard from '../../../Settings/components/Modal/LanguageModalCard'
import CurrencyModalCard from '../../../Settings/components/Modal/CurrencyModalCard'
import TimezoneModalCard from '../../../Settings/components/Modal/TimezoneModalCard'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Hidden from '@material-ui/core/Hidden'
import Drawer from '@material-ui/core/Drawer'

const useStyles = makeStyles((theme) => ({
	root: {
		width: '100%',
		[theme.breakpoints.up('md')]: {
			width: '60%'
		}
	},

	header: {
		[theme.breakpoints.up('md')]: {
			textAlign: 'center'
		}

	},
	modal: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	},
	paper: {
		width:516,
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 2, 2),
		borderRadius: 20,
		'box-shadow': 'none',
		"&:focus": {
			outline: 'none'
		}
	}
}))

const ChooseConsultant = (props) => {
	const classes = useStyles()

	const dispatch = useDispatch()
	const { consultants } = useSelector((state) => state.CounselingCenterReducer)
	const {
		language,
		currency,
		timezone
	} = useSelector(state => state.SettingsReducer)

	const { counselingCenterUsername } = useParams()

	useEffect(() => {
		dispatch(ConsultantAction.emptyConsultantName())
		dispatch(CounselingCenterAction.counselingCenterFetch(
			counselingCenterUsername,
			language,
			currency,
			timezone
		))
	}, [])

	const [openLanguageModal, setOpenLanguageModal] = React.useState(false)
	const [openCurrencyModal, setOpenCurrencyModal] = React.useState(false)
	const [openTimezoneModal, setOpenTimezoneModal] = React.useState(false)
	const handleOpenLanguageModal = () => {
		setOpenLanguageModal(true)
	}

	const handleCloseLanguageModal = () => {
		setOpenLanguageModal(false)
	}
	const handleOpenCurrencyModal = () => {
		setOpenCurrencyModal(true)
	}

	const handleCloseCurrencyModal = () => {
		setOpenCurrencyModal(false)
	}
	const handleOpenTimezoneModal = () => {
		setOpenTimezoneModal(true)
	}

	const handleCloseTimezoneModal = () => {
		setOpenTimezoneModal(false)
	}
	const languageModalBody = (
		<div className={classes.paper}>
			<LanguageModalCard handleClose={handleCloseLanguageModal}/>
		</div>
	)
	const currencyModalBody = (
		<div className={classes.paper}>
			<CurrencyModalCard handleClose={handleCloseCurrencyModal}/>
		</div>
	)
	const timezoneModalBody = (
		<div className={classes.paper}>
			<TimezoneModalCard handleClose={handleCloseTimezoneModal}/>
		</div>
	)

	return (
		<div>
			<Grid container justify='center'>
				<div className={classes.root}>
					<ConsultantCardProfile
						history={props.history}
						openLanguageModal={() => {
							handleOpenLanguageModal()
						}}
						openCurrencyModal={() => handleOpenCurrencyModal()}
						openTimezoneModal={() => handleOpenTimezoneModal()}
					/>
				</div>
			</Grid>
			<Container className={styles.ChooseConsultant} maxWidth="md">
				<div className={classes.header}>
					<H1>{I18n.t('consultant.consultantTitle')}</H1>
					<H4>{I18n.t('consultant.consultantDescription')}</H4>
				</div>
				<div>
					<Grid container justify="center">
						<Grid md={10} xs={12} item>
							<Grid container spacing={3}>
								{consultants && consultants.map(consultant => (
									<Grid item xs={12} md={6} key={consultant.username}>
										<ConsultantCard
											consultant={consultant}
											counselingCenterUsername={counselingCenterUsername}
										/>
									</Grid>
								))}
							</Grid>
						</Grid>
					</Grid>
				</div>
			</Container>

			<Hidden mdUp>
				<Drawer anchor={'bottom'} open={openCurrencyModal} onClose={handleCloseCurrencyModal}>
					{currencyModalBody}
				</Drawer>
			</Hidden>
			<Hidden mdUp>
				<Drawer anchor={'bottom'} open={openLanguageModal} onClose={handleCloseLanguageModal}>
					{languageModalBody}
				</Drawer>
			</Hidden>
			<Hidden mdUp>
				<Drawer anchor={'bottom'} open={openTimezoneModal} onClose={handleCloseTimezoneModal}>
					{timezoneModalBody}
				</Drawer>
			</Hidden>

			<Hidden mdDown>
				<Modal
					aria-labelledby="transition-modal-title"
					aria-describedby="transition-modal-description"
					className={classes.modal}
					open={openCurrencyModal}
					onClose={handleCloseCurrencyModal}
					closeAfterTransition
					BackdropComponent={Backdrop}
					BackdropProps={{
						timeout: 500
					}}
				>
					{currencyModalBody}
				</Modal>
			</Hidden>
			<Hidden mdDown>
				<Modal
					aria-labelledby="transition-modal-title"
					aria-describedby="transition-modal-description"
					className={classes.modal}
					open={openLanguageModal}
					onClose={handleCloseLanguageModal}
					closeAfterTransition
					BackdropComponent={Backdrop}
					BackdropProps={{
						timeout: 500
					}}
				>
					{languageModalBody}
				</Modal>
			</Hidden>


			<Hidden mdDown>
				<Modal
					aria-labelledby="transition-modal-title"
					aria-describedby="transition-modal-description"
					className={classes.modal}
					open={openTimezoneModal}
					onClose={handleCloseTimezoneModal}
					closeAfterTransition
					BackdropComponent={Backdrop}
					BackdropProps={{
						timeout: 500
					}}
				>
					{timezoneModalBody}
				</Modal>
			</Hidden>
		</div>
	)
}

export default ChooseConsultant
